<template src="./seguimientoOverlay.html"></template>

<script>
import TarjetasNuevas from "../TarjetasNuevas/TarjetasNuevasMomento";
export default {
  data() {
    return {
    }
  },
  created() {
  },
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
    variablesFormulario: {
      type: Array,
      default: [],
    },
    nombreFormulario: {
      type: String,
      default: "",
    },
    coleccion: {
      type: String,
      default: null,
    },
    idFormulario: {
      type: String,
      default: "",
    },
    texto_introductorio: {
      type: String,
      default: null,
    },
    cerrable: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    TarjetasNuevas,
  },
  methods: {
    cerrarOverlay() {
      try {
        this.$emit("cerrarOverlay", this.overlay);
      } catch (error) {}
    },
  },
};
</script>

<style src="./seguimientoOverlay.scss" lang="scss" scoped>
</style>
<style  lang="scss" >
.v-overlay {
  .v-overlay__content{
    width: 80%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TimeLine/TimeLineTareas/seguimientoOverlay/seguimientoOverlay.vue